// extracted by mini-css-extract-plugin
module.exports = {"noData":"noData_noData__1Nvk3","title":"noData_title__2jlFQ","boxIcon":"noData_boxIcon__p-GVk"};